import { toggleCategory } from "../../../lib/utils/stencilUtils";
import { useCategories } from "../../../lib/hooks/useCategories";

const RenderCategories = ({
    selectedCategories,
    setSelectedCategories
}) => {

  const { categories } = useCategories();
  return (
    <div className="scrollable-lhs scroll-invis" style={{ paddingTop: "5px" }}>
      {categories?.map((category) => {
        return (
          <a
            key={`category-${category.id}`}
            id={category.id}
            className={`${
              selectedCategories.includes(category.id)
                ? "stencil-sidebar-text-focused"
                : "stencil-sidebar-text"
            }`}
            onClick={() => 
                toggleCategory(
                    category.id,
                    selectedCategories,
                    setSelectedCategories
                )}
          >
            {`${category.id} - ${category.name}`}
          </a>
        );
      })}
    </div>
  );
};

export default RenderCategories;
